import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ShieldCheck, PaperPlaneTilt, CircleNotch, CheckCircle } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try { await api.post("/auth/forgot", { email }); } catch (_) {}
    // Always neutral — never reveals whether an account exists.
    setSent(true);
    setSubmitting(false);
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6" data-testid="forgot-page">
      <div className="max-w-md w-full border border-border bg-surface rounded-md p-8">
        <div className="h-10 w-10 bg-primary rounded flex items-center justify-center">
          <ShieldCheck size={22} weight="fill" className="text-white" />
        </div>
        {sent ? (
          <>
            <div className="mt-5 text-primary"><CheckCircle size={32} weight="duotone" /></div>
            <h1 className="mt-3 t-section-title" data-testid="forgot-sent-title">Check your inbox</h1>
            <p className="mt-2 t-support text-muted-foreground">
              If an account exists for that email, a password reset link has been sent.
              The link is single-use and expires in 60 minutes.
            </p>
            <Link to="/login" className="mt-5 inline-block text-sm text-primary hover:underline">Back to sign in</Link>
          </>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form">
            <p className="mt-5 text-[11px] uppercase tracking-[0.25em] text-muted-foreground">Password reset</p>
            <h1 className="mt-2 font-display font-extrabold tracking-tighter text-2xl">Forgot your password?</h1>
            <p className="mt-2 t-support text-muted-foreground">
              Enter your account email and we will send a secure reset link.
            </p>
            <label className="block mt-5 text-xs font-semibold uppercase tracking-wide text-muted-foreground">Email</label>
            <input
              data-testid="forgot-email-input" type="email" required autoComplete="username"
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 w-full border border-border bg-background px-4 py-3 text-sm rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
            />
            <button
              data-testid="forgot-submit-button" type="submit" disabled={submitting}
              className="mt-5 w-full flex items-center justify-center gap-2 px-6 py-3.5 text-sm font-semibold uppercase tracking-[0.15em] bg-primary text-primary-foreground hover:bg-primary/90 disabled:opacity-60 transition-colors"
            >
              {submitting ? <CircleNotch size={18} className="animate-spin" weight="bold" /> : <PaperPlaneTilt size={18} weight="bold" />}
              Send reset link
            </button>
            <Link to="/login" className="mt-4 inline-block text-sm text-primary hover:underline">Back to sign in</Link>
          </form>
        )}
      </div>
    </div>
  );
}
